import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useApplicantData } from '../../hooks/useApplicantData';
import usePersonMartialStatusDispatch from '../../hooks/usePersonMartialStatusDispatch';

import useStepPost from '../../hooks/useStepPost';
import {
  APPLICANT_TYPES,
  APPLICATION_MARTIAL_STATUS_TYPE,
} from '../../util/constants';
import { getApplicantData } from '../../util/helpers/applicantDataHelper';
import { parseEnumType } from '../../util/helpers/enumMappers';
import SelectList from '../SelectList/SelectList';
import useGtmStepHook from '../../util/hooks/useGtmStepHook';
import { retrieveFromSessionStorage } from '../../util/helpers/sessionStorageHelper';
import { ACCOUNT_TYPE_GTM } from '../../constants/sessionStorage';
import { gtmStepHelper } from '../../util/helpers/gtmHelper';
import { ACCOUNT_STEP_COMPLETE, ACCOUNT_STEP_VIEW } from '../../util/gtmEvents';

const MaritalStatusForm = ({ nextPath, onModalClose }) => {
  const { onSuccess } = useStepPost({ nextPath, onModalClose });
  const { t } = useTranslation();
  const { personMartialStatusDispatch } = usePersonMartialStatusDispatch();
  const ApplicantData = useApplicantData(APPLICANT_TYPES.MAIN);

  const { gtmStepEvent } = useGtmStepHook();
  const accountGtmType = retrieveFromSessionStorage(ACCOUNT_TYPE_GTM);

  useEffect(() => {
    if (ApplicantData?.PersonName && ApplicantData?.PersonBirthday) {
      gtmStepHelper({
        gtmStepEvent,
        eventName: ACCOUNT_STEP_VIEW,
        stepLabel: 'Marital Status',
        accountType: accountGtmType,
        accountName: ApplicantData?.PersonName,
        accountDateOfBirth: ApplicantData?.PersonBirthday,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGtmEvent = () => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_COMPLETE,
      stepLabel: 'Marital Status',
      accountType: accountGtmType,
      accountName: ApplicantData?.PersonName,
      accountDateOfBirth: ApplicantData?.PersonBirthday,
    });
  };

  const onClick = (value) => {
    personMartialStatusDispatch({
      personUid: ApplicantData?.PersonUid,
      data: {
        MaritalStatus: value,
      },
      onSuccess,
      defaultValues: {
        MaritalStatus: parseEnumType(
          APPLICATION_MARTIAL_STATUS_TYPE,
          getApplicantData(
            ApplicantData,
            'PersonMaritalStatus',
            'MaritalStatus',
          ),
        ),
      },
    });
    handleGtmEvent();
  };

  const options = () => [
    {
      title: t('retirementMaritalStatus.single'),
      onClick: () => onClick(parseEnumType(APPLICATION_MARTIAL_STATUS_TYPE, 1)),
      dataCy: 'button-single',
    },
    {
      title: t('retirementMaritalStatus.married'),
      onClick: () => onClick(parseEnumType(APPLICATION_MARTIAL_STATUS_TYPE, 2)),
      dataCy: 'button-married',
    },
    {
      title: t('retirementMaritalStatus.divorced/separated'),
      onClick: () => onClick(parseEnumType(APPLICATION_MARTIAL_STATUS_TYPE, 3)),
      dataCy: 'button-divorced',
    },
    {
      title: t('retirementMaritalStatus.divorced/widowed'),
      onClick: () => onClick(parseEnumType(APPLICATION_MARTIAL_STATUS_TYPE, 4)),
      showDivider: false,
      dataCy: 'button-widowed',
    },
  ];

  return <SelectList options={options()} onlyTitle titleWeight={400} />;
};

MaritalStatusForm.propTypes = {
  nextPath: PropTypes.string,
  onModalClose: PropTypes.func,
};

export default MaritalStatusForm;
